// src/services/AuthStorage.js

const TOKEN_KEY = 'authToken';
const USER_DATA_KEY = 'userData';
const ACCESSIBLE_ROUTES_KEY = 'accessibleRoutes'; // New key for accessible routes
const REMEMBER_ME_EMAIL_KEY = 'rememberMeEmail'; // New key for remember me email

export const AuthStorage = {
	getToken: () => {
		return localStorage.getItem(TOKEN_KEY);
	},

	setToken: (token) => {
		localStorage.setItem(TOKEN_KEY, token);
	},

	removeToken: () => {
		localStorage.removeItem(TOKEN_KEY);
	},

	setUserData: (userData) => {
		localStorage.setItem(USER_DATA_KEY, JSON.stringify(userData));
	},

	getUserData: () => {
		try {
			const userData = localStorage.getItem(USER_DATA_KEY);
			return userData ? JSON.parse(userData) : null;
		} catch (error) {
			console.error('Error parsing user data:', error);
			return null;
		}
	},

	removeUserData: () => {
		localStorage.removeItem(USER_DATA_KEY);
	},

	setAccessibleRoutes: (routes) => {
		localStorage.setItem(ACCESSIBLE_ROUTES_KEY, JSON.stringify(routes));
	},

	getAccessibleRoutes: () => {
		try {
			const routes = localStorage.getItem(ACCESSIBLE_ROUTES_KEY);
			return routes ? JSON.parse(routes) : [];
		} catch (error) {
			console.error('Error parsing accessible routes:', error);
			return [];
		}
	},

	removeAccessibleRoutes: () => {
		localStorage.removeItem(ACCESSIBLE_ROUTES_KEY);
	},

	setRememberedEmail: (email) => {
		localStorage.setItem(REMEMBER_ME_EMAIL_KEY, email);
	},

	getRememberedEmail: () => {
		return localStorage.getItem(REMEMBER_ME_EMAIL_KEY);
	},

	removeRememberedEmail: () => {
		localStorage.removeItem(REMEMBER_ME_EMAIL_KEY);
	}
};
